// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-fab-container.fab-container{bottom:2vh;position:fixed;margin:1em;right:5vw}\n", ""]);
// Exports
module.exports = exports;
